'use es6';

import http from 'hub-http/clients/apiClient';
import formatBusinessUnits from 'reference-resolvers/formatters/formatBusinessUnits';
export const createGetAllBusinessUnits = ({
  httpClient
}) => () => httpClient.get('business-units/v1/business-units').then(formatBusinessUnits);
export const getAllBusinessUnits = createGetAllBusinessUnits({
  httpClient: http
});